module.exports = __webpack_public_path__ + "static/media/IMG-4.069d65f0.jpg";